// Product-specific color configurations
export const productColors = {
  rush: {
    primary: '#8d382b',
    primaryRgb: '141, 56, 43',
    hover: '#7a2f24',
    light: 'rgba(141, 56, 43, 0.1)',
    medium: 'rgba(141, 56, 43, 0.5)',
    gradient: 'from-[#8d382b] to-[#7a2f24]',
    gradientLight: 'from-[#8d382b]/20 to-[#8d382b]/5',
    shadow: 'shadow-[#8d382b]/20',
    shadowHover: 'hover:shadow-[#8d382b]/30'
  },
  synaptiq: {
    primary: '#795e4f',
    primaryRgb: '121, 94, 79',
    hover: '#6a5144',
    light: 'rgba(121, 94, 79, 0.1)',
    medium: 'rgba(121, 94, 79, 0.5)',
    gradient: 'from-[#795e4f] to-[#6a5144]',
    gradientLight: 'from-[#795e4f]/20 to-[#795e4f]/5',
    shadow: 'shadow-[#795e4f]/20',
    shadowHover: 'hover:shadow-[#795e4f]/30'
  },
  vitra: {
    primary: '#d8bd97',
    primaryRgb: '216, 189, 151',
    hover: '#c9a87d',
    light: 'rgba(216, 189, 151, 0.1)',
    medium: 'rgba(216, 189, 151, 0.5)',
    gradient: 'from-[#d8bd97] to-[#c9a87d]',
    gradientLight: 'from-[#d8bd97]/20 to-[#d8bd97]/5',
    shadow: 'shadow-[#d8bd97]/20',
    shadowHover: 'hover:shadow-[#d8bd97]/30'
  }
};

// Helper function to get color classes for a product
export const getProductColors = (productId) => {
  return productColors[productId] || productColors.rush; // Default to rush colors
};
